import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { client } from '../common';

type Variables = {
  score: number;
  reservationId: number;
  feedback?: string;
  carConditionRating?: number | null;
  cleanlinessRating?: number | null;
  pickupReturnRating?: number | null;
  appExperienceRating?: number | null;
  customerSupportRating?: number | null;
  accessMethod?: string | null;
  contactedParty?: string | null;
  hadIssue?: string | null;
  issueContact?: string | null;
  supportChannel?: string | null;
  supportResolved?: string | null;
};
export type CreateReviewResponse = {
  data: {
    id: number;
  };
};

export const useCreateReview = createMutation<
  CreateReviewResponse,
  Variables,
  AxiosError
>({
  mutationFn: async (variables) =>
    client({
      url: 'v2/reviews',
      method: 'POST',
      data: {
        score: variables.score,
        reservation_id: Number(variables.reservationId),
        feedback: variables.feedback || undefined,
        car_condition_rating: variables.carConditionRating ?? undefined,
        cleanliness_rating: variables.cleanlinessRating ?? undefined,
        pickup_and_return_rating: variables.pickupReturnRating ?? undefined,
        app_and_experience_rating: variables.appExperienceRating ?? undefined,
        customer_support_rating: variables.customerSupportRating ?? undefined,
        access_method: variables.accessMethod ?? undefined,
        contacted_party: variables.contactedParty ?? undefined,
        had_issue: variables.hadIssue ?? undefined,
        issue_contact: variables.issueContact ?? undefined,
        support_channel: variables.supportChannel ?? undefined,
        support_resolved: variables.supportResolved ?? undefined,
      },
    })
      .then((response) => response.data)
      .catch((err: any) => {
        throw new Error(err.response.data.errors.join(', '));
      }),
});
